import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import AppStores from '../../AppStores';
import RichText, { all } from '../../../Core/RichText';
import { isNotEmpty } from '../../../../utils';

import {
  Wrapper,
  Content,
  Features,
  Product,
  Img,
  Banner,
  RatingWrapper,
  StarRating,
  UserCounts,
  StyledCtas,
} from './styles';

const richTextContentAsTitle = (_, children) =>
  isNotEmpty(children) ? <h2>{children}</h2> : null;

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: richTextContentAsTitle,
    [BLOCKS.HEADING_2]: richTextContentAsTitle,
  },
};

const DigitalProductBanner = ({ data = null }) => {
  if (!data) return null;

  const {
    imageDam,
    heading,
    bodyCopy,
    component,
    badges,
    ctas,
    imagePositioning,
    imageLink,
    ariaLabel,
    appRating,
    numberOfUsers,
  } = data;

  return (
    <Banner className={`${component} ${imagePositioning}`}>
      <Wrapper className={imagePositioning}>
        {(heading || bodyCopy) && (
          <Content>
            {heading && <RichText document={heading} options={header} />}
            {bodyCopy && <RichText document={bodyCopy} options={all} />}
            {(appRating || numberOfUsers) && (
              <RatingWrapper>
                {appRating && <StarRating>{appRating}</StarRating>}
                {numberOfUsers && <UserCounts>{numberOfUsers}</UserCounts>}
              </RatingWrapper>
            )}
            {(badges || ctas) && (
              <Features>
                {badges && <AppStores badges={badges} />}
                {ctas && <StyledCtas ctas={ctas} direction="row" />}
              </Features>
            )}
          </Content>
        )}
        {imageDam && (
          <Product>
            {imageLink ? (
              // TODO - change Gatsby Link?
              <a href={imageLink} aria-label={ariaLabel}>
                <Img
                  src={imageDam}
                  alt={imageDam.altText || ''}
                  role="presentation"
                />
              </a>
            ) : (
              <Img src={imageDam} alt={imageDam.altText || ''} />
            )}
          </Product>
        )}
      </Wrapper>
    </Banner>
  );
};

DigitalProductBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default DigitalProductBanner;
